var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"stat-circle",style:(`width: ${_vm.height}px;`),attrs:{"viewBox":"0 0 20 20"}},[_c('circle',{staticClass:"bg",attrs:{"cx":"10","cy":"10","r":"8"}}),_c('circle',{staticClass:"progress",attrs:{"cx":"10","cy":"10","r":"8","stroke-dashoffset":_vm.dashOffset,"transform":"rotate(-90, 10, 10)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }